import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import LazyImage from 'components/LazyImage';
import ExclusiveBadge from 'components/ExclusiveBadge';
import ThreeSixtyBadge from 'components/ThreeSixtyBadge';
import defaultMobileImage from './images/defaultMobileImage.jpg';
import defaultTabletImage from './images/defaultTabletImage.jpg';
import cn from './styles.local.less';

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';
const DEFAULT_DISPLAY_TYPE = 'default';
const SECONDARY_DISPLAY_TYPE = 'secondary';

export default class ImageContainer extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    has360Images: PropTypes.bool,
    isAvailable: PropTypes.bool,
    isGridView: PropTypes.bool,
    isExclusive: PropTypes.bool,
    link: PropTypes.string.isRequired,
    src: PropTypes.array,
    type: PropTypes.oneOf([DESKTOP, MOBILE]).isRequired,
    displayType: PropTypes.oneOf([
      DEFAULT_DISPLAY_TYPE,
      SECONDARY_DISPLAY_TYPE,
    ]),
  };

  static defaultProps = {
    displayType: DEFAULT_DISPLAY_TYPE,
  };

  renderContainer({ className, defaultSrc }) {
    const {
      className: classNameProp,
      src = defaultSrc,
      has360Images,
      isAvailable,
      isExclusive,
      link,
    } = this.props;
    const isDefaultSrc = src === defaultSrc;

    return (
      <a
        className={cns(className, classNameProp)}
        target="_blank"
        href={link}
        rel="noreferrer"
      >
        <LazyImage
          alt="car"
          className={cn.image}
          placeholder={defaultSrc}
          src={src}
        />

        {isAvailable ? (
          <Fragment>
            {isDefaultSrc ? (
              <span className={cn.placeholder}>
                {__('imageContainer.placeholder')}
              </span>
            ) : null}
            {isExclusive ? <ExclusiveBadge /> : null}
            {has360Images ? <ThreeSixtyBadge /> : null}{' '}
          </Fragment>
        ) : (
          <div className={cn.unavailablePlaceholder}>
            <strong>{__('imageContainer.unavailablePlaceholder')}</strong>
          </div>
        )}
      </a>
    );
  }

  render() {
    const { displayType, isGridView, type } = this.props;

    if (isGridView) {
      return this.renderContainer({
        className: cns(cn.tabletImageContainer, cn.gridView),
        defaultSrc: defaultTabletImage,
      });
    }

    switch (type) {
      case MOBILE:
        return this.renderContainer({
          className: cns(cn.imageContainer, {
            'visible-xs-block': !isGridView,
          }),
          defaultSrc: defaultMobileImage,
        });

      case DESKTOP:
        return this.renderContainer({
          className: cns(
            { [cn.tabletImageContainer]: displayType === DEFAULT_DISPLAY_TYPE },
            {
              [cn.tabletImageContainerSecondary]:
                displayType === SECONDARY_DISPLAY_TYPE,
            },
            { 'hidden-xs': !isGridView },
          ),
          defaultSrc: defaultTabletImage,
        });

      default:
        return null;
    }
  }
}
